import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../../../Baseurl";
import { useParams, useNavigate } from "react-router-dom";
import AdminSidebar from "../../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../../component/AdminComp/AdminTopbar";
import Swal from "sweetalert2";
import EducationCategoryNavbar from "./EducationCategoryNavbar";

const EditEducationCategory = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [title, setTitle] = useState("");

  const generateSlug = (text) => {
    return text.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9\-]/g, "");
  };

  // Fetch data on mount
  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const res = await axios.get(`${baseurl}getEducationCategoryById/${id}`);
        setTitle(res.data.data.education_title);
      } catch (err) {
        console.error("Error fetching category:", err);
        Swal.fire("Error", "Failed to load category", "error");
      }
    };
    fetchCategory();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        education_title: title,
        slug: generateSlug(title),
      };

      await axios.put(`${baseurl}updateEducationCategory/${id}`, payload);
      Swal.fire("Success", "Category updated successfully!", "success").then(() => {
        navigate(-1); // go back
      });
    } catch (err) {
      console.error("Update error:", err);
      Swal.fire("Error", "Failed to update category", "error");
    }
  };

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid text-start">
          <EducationCategoryNavbar />
          <div className="crd1">
            <h4 className="mb-3">Edit  </h4>
            <div className="row">
              <div className="col-md-6">
                <form onSubmit={handleSubmit} className="row g-3 text-start">
                  <div className="col-md-12">
                    <label>Title</label>
                    <input
                      type="text"
                      className="form-control"
                      required
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                    />
                  </div>

                  <div className="col-12 text-end">
                    <button type="submit" className="btn btn-primary">Update</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditEducationCategory;
